import {
  breakpointSizes,
  getBreakpointDown,
  getFontCss,
  styleConstants,
  themeConstants,
} from '@paywithextend/components'
import helperCss from 'ext-ui/style/helperCss'
import { createGlobalStyle, css } from 'styled-components'

const BaseGlobalStyles = createGlobalStyle`
  * {
    box-sizing: border-box;
    padding: 0;
    margin: 0;
    -webkit-font-smoothing: antialiased;
    -moz-osx-font-smoothing: grayscale;
  }

  .ReactCollapse--collapse {
    transition: height ${styleConstants.transitionSpeed.slow} ease-out, opacity ${styleConstants.transitionSpeed.slow} ease-out;
  }

  body {
    ${getFontCss(16, themeConstants.colors.font_primary, styleConstants.fontFamilies.regular)}

    &.modal-open {
      overflow: hidden;

      ${getBreakpointDown(breakpointSizes.XSM)(css`
        position: fixed;
      `)}
    }
  }

  input:focus {
    outline: none;
  }

  #content {
    display: flex;
  }

  a {
    text-decoration: none;
    color: inherit;
  }

  button {
    border: none;
  }

  th {
    text-align: left;
  }

  input[type=number]::-webkit-inner-spin-button,
  input[type=number]::-webkit-outer-spin-button {
    -webkit-appearance: none;
    margin: 0;
  }

  ${helperCss}
`

export default BaseGlobalStyles
